import { render } from "./capacity.vue?vue&type=template&id=554c233b"
import script from "./capacity.vue?vue&type=script&lang=js"
export * from "./capacity.vue?vue&type=script&lang=js"

import "./capacity.vue?vue&type=style&index=0&id=554c233b&lang=scss"

import exportComponent from "F:\\Work\\Lu\\_pz\\pzvtour\\pzvtour-userbackend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__